import { Classes, Colors, IconSize } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'src/components/icons/types';

export const Inbound: React.VFC<IconProps> = ({
  className,
  color = Colors.GRAY1,
  iconSize = IconSize.STANDARD,
}) => (
  <svg
    className={classNames('sd-icon', Classes.ICON, className)}
    fill="none"
    height={iconSize}
    viewBox="0 0 60 60"
    width={iconSize}
  >
    <path
      clipRule="evenodd"
      d="M24.0025 30.2435C23.879 36.7649 18.5536 42.0135 12.0023 42.0135C5.37363 42.0135 0 36.6401 0 30.0118C0 23.3835 5.37363 18.0101 12.0023 18.0101C18.5508 18.0101 23.8744 23.2542 24.0023 29.7717C24.0586 29.0498 24.3672 28.4087 24.8424 27.934L36.9546 15.8539C37.4818 15.3272 38.1924 15 39.0124 15C40.6233 15 41.9965 16.3837 41.9965 17.9933C41.9965 18.8127 41.6736 19.5797 41.1464 20.1065L34.0096 27.0189L57.0712 27.0189C58.682 27.0189 60 28.4022 60 30.0118C60 31.6214 58.682 32.9903 57.0712 32.9903C55.9972 32.9903 48.3198 32.9903 34.0389 32.9903L41.1464 39.9473C41.6736 40.4741 41.9965 41.1883 41.9965 42.0077C41.9965 43.6173 40.6233 45 39.0124 45C38.1924 45 37.4818 44.6982 36.9546 44.1422L24.8717 32.0604C24.3948 31.5839 24.0618 30.9639 24.0025 30.2435Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
